<template>
  <div>
    <Loader v-if="loading"></Loader>
    <div class="wrraper" v-else>
      <!-- Start Breadcrumb -->
      <Breadcrumb
        :items="items"
        :show_print="true"
        :excelFile="true"
        :excelData="excelData"
      />
      <!-- End Breadcrumb -->
      <!-- start of searchSection  -->
      <SearchSection
        @filterTable="searchTable"
        pageTitle="تنفيذ شغل المؤسسات"
      ></SearchSection>
      <!-- end of searchSection  -->

      <!-- notFound  -->
      <Loader v-if="lodaing" class="sub-loader"></Loader>
      <div v-else>
        <Notfound v-if="!searchItems"></Notfound>
        <div v-else>
          <!-- Start Statistics Card-->
          <ul class="all-state-count">
            <li>
              <div class="state-count">
                <span>عدد عملاء تنفيذ شغل المؤسسات:</span>
                <span>{{ table_length }}</span>
              </div>
            </li>
          </ul>
          <!-- End Statistics Card-->

          <!-- Start Main Section -->
          <main class="table-print main-table">
            <!-- start of  header of printSection  -->
            <PrintHead
              :title="'عملاء تنفيذ شغل المؤسسات'"
              :number="table_length"
            ></PrintHead>
            <!-- end of header of printSection  -->
            <div
              v-for="i in rows"
              :key="i.id"
              :class="companySearch ? 'border-tables' : ''"
            >
              <div :class="!companySearch ? 'user-companies-tables' : ''">
                <div class="user-name" v-if="companySearch == false">
                  <span> Enterprice Name </span>
                  <p
                    @click="calculate(i.amount)"
                    style="
                      cursor: pointer;
                      font-size: 15px;
                      color: red;
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      gap: 0px;
                    "
                  >
                    {{ i.name }}
                    <span
                      v-if="i.works && i.works.length > 0"
                      @click.stop="toggleTableCollapse(i.id)"
                      :class="[
                        'collapse-icon',
                        collapsedTables[i.id] ? 'collapsed' : 'expanded',
                      ]"
                    >
                      <v-icon> far fa-chevron-double-down </v-icon>
                    </span>
                  </p>
                </div>
                <v-data-table
                  class="thumb table_company enterprise_style"
                  :headers="headers"
                  :items="getTableItems(i)"
                  :loading="lodaing"
                  :loading-text="$t('table.loadingData')"
                  v-model="selected"
                  :single-select="singleSelect"
                  item-key="id"
                  :items-per-page="getTableItems(i).length"
                  hide-default-footer
                  :expanded="expanded"
                >
                  <!-- expanded section  -->
                  <template v-slot:[`item.index`]="{ index }">
                    {{ index + 1 }}
                  </template>
                  <template v-slot:[`item.company.name`]="slotData">
                    <button type="button" @click="columnClick(slotData)">
                      {{ slotData.item.company.name }}
                    </button>
                  </template>
                  <template v-slot:[`item.reference`]="{ item }">
                    <span v-if="item.reference"> {{ item.reference }} </span>
                    <span v-else> ----- </span>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <div class="pdf-file text-left d-flex align-items-center">
                        <div class="checked ml-2">
                          <v-chip color="green" rounded v-if="item.is_saved"
                            ><i class="fal fa-check"></i
                          ></v-chip>
                        </div>
                        <div class="text flex-grow-1">
                          <div class="sub">
                            <div class="items">
                              <p>Amount</p>
                              <p>{{ item.paid }}</p>
                            </div>
                            <div class="items">
                              <p>Name</p>
                              <p>{{ item.company.name }}</p>
                            </div>
                            <div class="items bagItems">
                              <p>Address</p>
                              <p>{{ item.company.address }}</p>
                            </div>
                            <div class="items">
                              <p>A/C NO</p>
                              <p>{{ item.company.account_number }}</p>
                            </div>
                            <div class="items">
                              <p>SWIFT CODE</p>
                              <p>{{ item.company.swift_number }}</p>
                            </div>
                            <div class="items bagItems">
                              <p>REFERENCE NO</p>
                              <p v-if="item.reference">{{ item.reference }}</p>
                              <p v-else>-----</p>
                            </div>
                            <div class="items">
                              <p>BANK NAME</p>
                              <p>{{ item.company.bank.name }}</p>
                            </div>
                            <div class="items">
                              <p>Product</p>
                              <p>{{ item.company.products[0].name }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </template>
                  <!-- Select no data State -->
                  <template v-slot:no-data>
                    <span> {{ i.name }} ({{ i.works.length }}) </span>
                  </template>

                  <!-- Text Number -->
                  <template v-slot:[`item.companyLength`]="{ item }">
                    <span style="width: 100%; height: 100%">{{
                      item.company.name.length
                    }}</span>
                  </template>

                  <!-- Text Number -->
                  <template v-slot:[`item.is_collected`]="{ item }">
                    <v-chip color="green" rounded v-if="item.is_collected"
                      ><i class="fal fa-check"></i
                    ></v-chip>
                    <v-chip color="red" rounded v-else
                      ><i class="fal fa-times"></i
                    ></v-chip>
                  </template>

                  <!-- created at -->
                  <template v-slot:[`item.created_at`]="{ item }">
                    <span
                      >{{ item.created_at }} <br />
                      {{ item.time_at }}</span
                    >
                  </template>

                  <!-- Status -->
                  <template v-slot:[`item.paid`]="{ item }">
                    <!-- {{ Number(item.paid).toLocaleString() }} {{ item.currency }} -->
                    <button
                      type="button"
                      @click="totalAmount(item, i)"
                      style="width: 100%; height: 100%"
                      :class="{
                        checkItem: allCalcItems.includes(item),
                      }"
                    >
                      {{ Number(item.paid).toLocaleString() }}
                      {{ item.currency }}
                    </button>
                  </template>

                  <!-- Select -->
                  <template v-slot:[`header.selected`]>
                    <span>حدد</span>
                    <!-- <v-simple-checkbox
                        class="ma-0 pa-0"
                        :value="isAllSelected(i.works)"
                        @click.stop="toggleSelectAll(i.works)"
                      /> -->
                  </template>
                  <template v-slot:[`item.selected`]="{ item }">
                    <v-simple-checkbox
                      class="ma-0 pa-0 check_style"
                      :value="item.is_saved"
                      @click.stop="toggleSelect(item)"
                    />
                  </template>
                  <!-- Select row field -->
                  <template v-slot:[`item.status`]="{ item }">
                    <v-chip
                      color="#d7c100"
                      class="mr-1"
                      v-if="item.status == 'pending'"
                    >
                      Pending
                    </v-chip>
                    <v-chip
                      color="green"
                      class="mr-1"
                      v-if="item.status == 'confirmed'"
                    >
                      Confirmed
                    </v-chip>
                    <v-chip
                      color="red"
                      class="mr-1"
                      v-if="item.status == 'refused'"
                    >
                      Refused
                    </v-chip>
                  </template>
                  <!-- Confirm-->
                  <template v-slot:[`item.confirm`]="{ item }">
                    <div
                      class="_actions actions2"
                      v-if="item.status == 'pending'"
                    >
                      <button
                        type="button"
                        class="accept confirm_btn"
                        @click="acceptCompany(item.id)"
                      >
                        <i class="far fa-check"></i>
                      </button>
                      <button
                        type="button"
                        class="reject confirm_btn"
                        @click="rejectCompany(item.id)"
                      >
                        <i class="far fa-times"></i>
                      </button>
                    </div>
                    <span v-if="item.status != 'pending'">-----</span>
                  </template>
                  <!-- Select actions-->
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="_actions">
                      <!-- <v-icon class="edit" small @click="editItem(item)">
                          fal fa-edit
                        </v-icon> -->
                      <v-icon class="delete" small @click="deleteItem(item)">
                        fal fa-trash
                      </v-icon>
                    </div>
                  </template>
                  <!-- Confirm-->
                  <template v-slot:[`item.pdf_file`]="{ item }">
                    <button
                      type="button"
                      @click="generateReport(item)"
                      style="font-size: 20px"
                    >
                      <i class="fal fa-download"></i>
                    </button>
                  </template>

                  <!-- ======================== Start Top Section ======================== -->
                  <template v-slot:top>
                    <!-- Delete dialog -->
                    <v-dialog v-model="dialogDelete" max-width="500px">
                      <v-card>
                        <v-card-title class="text-h5 justify-center">{{
                          $t("table.deletedialog.areYouSure")
                        }}</v-card-title>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="#1B5E20" @click="deleteItemConfirm"
                            >{{ $t("table.deletedialog.ok") }}
                            <span
                              class="btn_loader_model"
                              v-if="loadingBtnDialog"
                            ></span
                          ></v-btn>
                          <v-btn
                            color="#F44336"
                            @click="dialogDelete = false"
                            >{{ $t("table.deletedialog.cancel") }}</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <!-- Add & Delete -->
                  </template>
                  <!-- ======================== End Top Section ======================== -->
                </v-data-table>
              </div>
              <!-- =========== Add Total After Every Company =========-->
              <div class="total-of-client" v-if="i.totalPerClient != 0">
                <p>
                  <bdi>
                    All Total Amounts for <span>" {{ i.name }} " : </span>
                    <span dir="rtl">
                      {{
                        parseFloat(
                          Number(i.totalPerClient).toFixed(),
                        ).toLocaleString()
                      }}
                      {{ i.works[0].currency }}
                    </span>
                  </bdi>
                </p>
              </div>
              <!-- =========== Add Total After Every Company =========-->
              <transition name="slide-fade" mode="out-in">
                <div
                  class="calculater"
                  v-if="
                    calculater.amount ==
                    parseFloat(Number(i.amount).toFixed()).toLocaleString()
                  "
                >
                  <button class="close" @click="calculater.amount = null">
                    <i class="fas fa-times"></i>
                  </button>
                  <div class="row justify-content-between">
                    <div class="col-lg-12 py-0">
                      <div class="divider">
                        <h4>حاسبة العميل</h4>
                        <hr
                          role="separator"
                          aria-orientation="horizontal"
                          class="v-divider theme--light"
                        />
                      </div>
                    </div>
                    <div class="col-lg-3 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          disabled
                          v-model="calculater.amount"
                        />
                        <label for="name_input" class="form-label"
                          >المبلغ
                        </label>
                      </div>
                    </div>
                    <div class="col-lg-3 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="number"
                          step="any"
                          class="form-control"
                          v-model="calculater.mulit"
                        />
                        <label for="name_input" class="form-label">ضرب </label>
                      </div>
                    </div>
                    <div class="col-lg-3 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          v-model="calculater.divide"
                        />
                        <label for="name_input" class="form-label">قسمة </label>
                      </div>
                    </div>
                    <div class="col-lg-3 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          disabled
                          class="form-control"
                          v-model="calculaterAll"
                        />
                        <label for="name_input" class="form-label"
                          >الإجمالي
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </main>
          <!-- End Main Section -->

          <div class="info-pill" v-if="calcResult">
            <p>
              All Total Amounts :
              <span :class="{ redColor: calcResult < 0 }"
                >{{ parseFloat(calcResult).toLocaleString() }}
                <i class="fal fa-coins"></i
              ></span>
            </p>
          </div>
          <!--Equation-->
          <div class="equation-wrapper" v-if="allCalcItems.length > 0">
            <div class="equation-content">
              <div class="main_title text-center">
                <h4>
                  معادلة حساب الفرق لعدد عمليات ( {{ allCalcItems.length }} ) <span v-if="selectedEnterpriseName"> -  {{ selectedEnterpriseName }}</span>
                </h4>
              </div>
              <form @submit.prevent="executeEquation">
                <span>(</span>
                <div class="input_wrapper top_label equation-input">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    v-model.trim="data.totalAmount"
                    readonly
                  />
                  <label for="name_input" class="form-label">
                    المبلغ الاجمالي
                  </label>
                </div>
                <div class="math_mark">×</div>
                <div class="rate_calc">
                  (
                  <div class="input_wrapper top_label equation-input">
                    <input
                      type="number"
                      step="any"
                      class="form-control"
                      v-model.trim="data.client_rate"
                    />
                    <label for="name_input" class="form-label">
                      ريت العميل
                    </label>
                  </div>
                  <div class="math_mark">-</div>
                  <div class="input_wrapper top_label equation-input">
                    <input
                      type="number"
                      step="any"
                      class="form-control"
                      v-model.trim="data.bank_rate"
                    />
                    <label for="name_input" class="form-label">
                      ريت البنك
                    </label>
                  </div>
                  ) )
                  <div class="math_mark">-</div>
                </div>
                <div class="input_wrapper top_label equation-input">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    v-model.trim="data.bank_comission"
                  />
                  <label for="name_input" class="form-label">
                    عمولة البنك
                  </label>
                </div>
                <div class="math_mark">=</div>
                <div class="input_wrapper top_label equation-input">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    v-model.trim="data.subtraction"
                    readonly
                  />
                  <label for="name_input" class="form-label"> الفرق </label>
                </div>
                <div class="text-center py-0">
                  <button class="button_style_1">تسجيل</button>
                </div>
              </form>
            </div>
          </div>
          <!--Equation-->
        </div>
      </div>

      <!-- start of searchSection  -->
      <SearchRecoredSection
        @filterTable="searchRecordTable"
        title="تجميعة اليوم لتنفيذ شغل المؤسسات"
      ></SearchRecoredSection>
      <!-- end of searchSection  -->

      <!--Recored Table-->
      <Loader v-if="lodaing_amount" class="sub-loader"></Loader>
      <div v-else>
        <Notfound v-if="!searchRecordItems"></Notfound>
        <div v-else>
          <!-- Start Statistics Card-->
          <ul class="all-state-count">
            <li>
              <div class="state-count">
                <span>عدد عمليات تقفيل اليوميه  لشغل المؤسسات:</span>
                <span>{{ last_amount.length }}</span>
              </div>
            </li>
          </ul>
          <!-- End Statistics Card-->
          <main class="main-table my-4">
            <v-data-table
              class="thumb row-pointer"
              :headers="headers_amount"
              :items="last_amount"
              :loading="lodaing_amount"
              :loading-text="$t('table.loadingData')"
              v-model="selected"
              :single-select="singleSelect"
              item-key="id"
              :items-per-page="last_amount.length"
              hide-default-footer
            >
              <!-- ================== You Can use any slots you want ================== -->
              <!-- ====== Select row field ====== -->
              <!-- Select no data State -->
              <template v-slot:no-data>
                {{ $t("table.noData") }}
              </template>
              <template v-slot:[`item.index`]="{ index }">
                {{ index + 1 }}
              </template>
              <!-- Select actions-->
              <template v-slot:[`item.total_price`]="{ item }">
                <span v-if="item.total_price < 0" class="redColor">
                  {{ Number(item.total_price).toLocaleString() }}
                </span>
                <span v-else-if="item.total_price > 0" class="greenColor">
                  {{ Number(item.total_price).toLocaleString() }}
                </span>
                <span v-else>
                  {{ Number(item.total_price).toLocaleString() }}
                </span>
              </template>
              <template v-slot:[`item.date`]="{ item }">
                {{ item.day }} - {{ item.date }} - {{ item.time }}
              </template>
              <template v-slot:[`item.details`]="{ item }">
                <v-icon class="show" small @click="showCollectBalance(item)">
                  fal fa-eye
                </v-icon>
              </template>
              <template v-slot:[`item.total_amount_collected`]="{ item }">
                <span>
                  {{ Number(item.total_amount_collected).toLocaleString() }}
                  {{ item.currency }}
                </span>
              </template>
              <template v-slot:[`item.works`]="{ item }">
                <span>
                  {{ item.works.length }}
                </span>
              </template>
              <template v-slot:[`item.amount_difference`]="{ item }">
                <span>
                  {{ Number(item.amount_difference).toLocaleString() }}
                  {{ item.currency }}
                </span>
              </template>
              <template v-slot:[`item.notes`]="{ item }">
                <v-icon class="show" small @click="showNotes(item)">
                  fal fa-eye
                </v-icon>
              </template>
              <!-- Select actions-->
              <template v-slot:[`item.actions`]="{ item }">
                <div class="_actions" v-if="item.deposit_status == 'pending'">
                  <v-icon class="edit" small @click="editItemDailyClose(item)">
                    fal fa-edit
                  </v-icon>
                  <v-icon class="delete" small @click="deleteItemDailyClose(item)">
                    fal fa-trash
                  </v-icon>
                </div>
                <div class="_actions actions2" v-else>
                  <span> -------- </span>
                </div>

              </template>
              <template v-slot:[`item.confirm`]="{ item }">
                <div class="_actions actions2">
                  <button
                    type="button"
                    class="confirm_btn normal"
                    @click="showMakeDepositDialog(item)"
                    v-if="item.deposit_status == 'pending'"
                  >
                    <i class="far fa-check"></i>
                  </button>
                  <span v-else> تم التاكيد </span>
                </div>
              </template>
              <!-- ======================== Start Top Section ======================== -->
              <template v-slot:top>
                <!-- Delete dialog -->
                <v-dialog v-model="dialogDeleteDailyClose" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5 justify-center">{{
                      $t("table.deletedialog.areYouSure")
                    }}</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#1B5E20" @click="deleteItemDailyCloseConfirm"
                        >{{ $t("table.deletedialog.ok") }}
                        <span
                          class="btn_loader_model"
                          v-if="loadingBtnDialogDailyClose"
                        ></span
                      ></v-btn>
                      <v-btn color="#F44336" @click="dialogDeleteDailyClose = false">{{
                        $t("table.deletedialog.cancel")
                      }}</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <!-- ======================== End Top Section ======================== -->
            </v-data-table>
          </main>
          
          <!-- ======================== Start Info Pills ======================== -->
           <div class="d-flex gap-2 info-pills-container">
            <div class="info-pill diff" v-if="last_amount && last_amount.length > 0">
            <p>
              All Collected Amounts :
              <span :class="{ redColor: totalLastAmountCollected < 0 }"
                >{{ parseFloat(totalLastAmountCollected).toLocaleString() }}
                <i class="fal fa-coins"></i
              ></span>
            </p>
          </div>
          <div class="info-pill diff" v-if="last_amount && last_amount.length > 0">
            <p>
              All Difference Amounts :
              <span :class="{ redColor: totalLastAmountDifference < 0 }"
                >{{ parseFloat(totalLastAmountDifference).toLocaleString() }}
                <i class="fal fa-coins"></i
              ></span>
            </p>
          </div>
           </div>
          <!-- ======================== End Info Pills ======================== -->

        </div>
      </div>
      <!--Recored Table-->

      <!-- Start Notes -->
      <v-dialog v-model="dialogNotes" width="1200" max-width="100%">
        <div class="my_card table-print pt-4 pb-4" v-if="itemToNotes">
          <h4 class="card-title text-center">الوصف</h4>
          <p class="text-center">
            {{ itemToNotes }}
            <i
              class="fal fa-copy copy-icon"
              @click="copyNotes"
              style="
                cursor: pointer;
                margin-right: 8px;
                color: #1976d2;
                font-size: 18px;
                transition: color 0.2s;
              "
              @mouseover="$event.target.style.color = '#1565c0'"
              @mouseleave="$event.target.style.color = '#1976d2'"
              title="نسخ النص"
            ></i>
          </p>
        </div>
      </v-dialog>
      <!-- End Notes -->

      <!-- Start Collect Balance Dialog -->
      <v-dialog v-model="dialogCollectBalance" width="1200" max-width="100%">
        <div
          class="my_card table-print"
          v-if="
            itemToCollectBalance.works && itemToCollectBalance.works.length > 0
          "
        >
          <div class="card-header">
            <h4 class="card-title">تفاصيل المعاملات</h4>
          </div>
          <main class="main-table">
            <!-- start of  header of printSection  -->
            <PrintHead
              :title="'أرصدة العملاء'"
              :hideHeader="true"
              :number="itemToCollectBalance.works.length"
            ></PrintHead>
            <!-- end of header of printSection  -->
            <v-data-table
              class="thumb row-pointer"
              :headers="works_details_headers"
              :items="itemToCollectBalance.works"
              :items-per-page="itemToCollectBalance.works.length"
              hide-default-footer
            >
              <!-- expanded section  -->
              <template v-slot:[`item.index`]="{ index }">
                {{ index + 1 }}
              </template>
              <template v-slot:[`item.paid`]="{ item }">
                <span>
                  {{ Number(item.paid).toLocaleString() }}
                  {{ item.currency }}
                </span>
              </template>
            </v-data-table>
          </main>
        </div>
      </v-dialog>
      <!-- End Collect Balance Dialog -->

      <!-- Start Make Deposit Dialog -->
      <v-dialog v-model="makeDepositDialog" width="1200" max-width="100%">
        <div class="create_wrapper my_card" v-if="makeDepositDialog">
          <div class="create_wrapper">
            <div class="">
              <div class="card-header">
                <h4 class="card-title">عمل ايداع</h4>
              </div>

              <!-- ==== Start Form ==== -->
              <form @submit.prevent="validateCreateForm">
                <div class="container">
                  <div class="row justify-content-between">
                    <div class="col-lg-3 py-0">
                      <div class="input_wrapper top_label disabled">
                        <input
                          type="number"
                          step="any"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="create_data.amount"
                          disabled
                        />
                        <label for="name_input" class="form-label">{{
                          $t("forms.labels.amount")
                        }}</label>
                      </div>
                    </div>
                    <div class="col-lg-3 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="number"
                          step="any"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="create_data.comission"
                        />
                        <label for="name_input" class="form-label">{{
                          $t("forms.labels.comission")
                        }}</label>
                      </div>
                    </div>
                    <div class="col-lg-3 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="number"
                          step="any"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="create_data.transfare_amount"
                        />
                        <label for="name_input" class="form-label">{{
                          $t("forms.labels.transfare_amount")
                        }}</label>
                      </div>
                    </div>
                    <div class="col-lg-3 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          readonly
                          type="text"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="total"
                        />
                        <label for="name_input" class="form-label">{{
                          $t("forms.labels.total")
                        }}</label>
                      </div>
                    </div>

                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label disabled">
                        <label class="form-label">{{
                          $t("forms.labels.safe")
                        }}</label>
                        <multiselect
                          v-model="create_data.safe"
                          :options="safes"
                          label="name"
                          track-by="name"
                          placeholder=" "
                          :searchable="true"
                          :allow-empty="false"
                          :show-labels="false"
                          disabled
                        >
                        </multiselect>
                      </div>
                    </div>

                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label auto_complete">
                        <label class="form-label"> إسم العميل</label>
                        <v-autocomplete
                          v-model="create_data.username"
                          :search-input.sync="searchOptions.search_users"
                          :items="users"
                          item-text="name"
                          return-object
                          :hide-no-data="!users"
                          dense
                        ></v-autocomplete>
                        <button
                          class="button_style_1 load_inline"
                          v-if="load_users"
                        >
                          <span class="btn_loader"></span>
                        </button>
                      </div>
                      <h6
                        class="mt-0 mb-0 mx-0 amount-section"
                        :class="{
                          redColor: create_data.username.amount < 0,
                          greenColor: create_data.username.amount > 0,
                        }"
                        v-if="create_data.username"
                      >
                        الرصيد :
                        {{
                          Number(create_data.username.amount).toLocaleString()
                        }}
                      </h6>
                    </div>

                    <div class="col-lg-12 py-0">
                      <div class="input_wrapper top_label date_input">
                        <label class="form-label">{{
                          $t("forms.labels.date")
                        }}</label>
                        <v-menu
                          v-model="dateMenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="create_data.date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="create_data.date"
                            @input="dateMenu = false"
                            no-title
                          ></v-date-picker>
                        </v-menu>
                      </div>
                    </div>

                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label">{{
                          $t("forms.labels.desc")
                        }}</label>
                        <textarea
                          v-model="create_data.desc"
                          v-on:keydown.enter.prevent="validateCreateForm"
                          class="form-control"
                          id="textarea_1"
                          rows="5"
                        ></textarea>
                      </div>
                    </div>

                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label">{{
                          $t("forms.labels.notes")
                        }}</label>
                        <textarea
                          v-on:keydown.enter.prevent="validateCreateForm"
                          v-model="create_data.notes"
                          class="form-control"
                          id="textarea_1"
                          rows="5"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="buttons_wrapper">
                  <button
                    class="button_style_1"
                    :class="{ buttonIndex: btnIsLoading }"
                    :disabled="btnIsLoading"
                  >
                    إضافة
                    <span class="btn_loader" v-if="btnIsLoading"></span>
                  </button>
                </div>
              </form>
              <!-- ==== End Form ==== -->
            </div>
          </div>
        </div>
      </v-dialog>
      <!-- End Make Deposit Dialog -->

      <!-- Start Edit Daily Close Dialog -->
      <v-dialog v-model="dialogEditDailyClose" width="1600" max-width="100%">
        <div class="create_wrapper my_card" v-if="dialogEditDailyClose">
          <div class="card-header">
            <h4 class="card-title">تعديل بيانات المعادلة</h4>
          </div>
          <!-- ==== Start Form ==== -->
          <div class="equation-wrapper" style="margin: 0;">
            <div class="equation-content" style="overflow-x: auto;">
              <form @submit.prevent="updateEquationData">
                <span>(</span>
                <div class="input_wrapper top_label equation-input">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    v-model.trim="edit_data.total_amount_collected"
                  />
                  <label class="form-label">المبلغ الاجمالي</label>
                </div>
                <div class="math_mark">×</div>
                <div class="rate_calc">
                  (
                  <div class="input_wrapper top_label equation-input">
                    <input
                      type="number"
                      step="any"
                      class="form-control"
                      v-model.trim="edit_data.client_rate"
                    />
                    <label class="form-label">ريت العميل</label>
                  </div>
                  <div class="math_mark">-</div>
                  <div class="input_wrapper top_label equation-input">
                    <input
                      type="number"
                      step="any"
                      class="form-control"
                      v-model.trim="edit_data.bank_rate"
                    />
                    <label class="form-label">ريت البنك</label>
                  </div>
                  <div class="math_mark">) </div>
                  <div class="math_mark">) </div>
                  <div class="math_mark">-</div>
                </div>
                <div class="input_wrapper top_label equation-input">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    v-model.trim="edit_data.bank_commission"
                  />
                  <label class="form-label">عمولة البنك</label>
                </div>
                <div class="math_mark">=</div>
                <div class="input_wrapper top_label equation-input">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    v-model.trim="edit_data.amount_difference"
                    readonly
                  />
                  <label class="form-label">الفرق</label>
                </div>
                <div class="text-center py-0" style="flex-shrink: 0;">
                  <button
                    class="button_style_1"
                    :class="{ buttonIndex: editBtnIsLoading }"
                    :disabled="editBtnIsLoading"
                  >
                    حفظ التعديلات
                    <span class="btn_loader" v-if="editBtnIsLoading"></span>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <!-- ==== End Form ==== -->
        </div>
      </v-dialog>
      <!-- End Edit Daily Close Dialog -->

      <!-- Start Image_Model -->
      <base-model
        @closeModel="model_1.show_model = false"
        :show="model_1.show_model"
      >
        <div class="image">
          <img
            v-if="model_1.model_img_src"
            :src="model_1.model_img_src"
            alt="..."
          />
        </div>
      </base-model>
      <!-- End Image_Model -->
    </div>

    <!-- pdf file  -->
    <section class="pdf-print">
      <div class="pdf-file text-left">
        <div class="text">
          <h3>Enterprise job execution data</h3>
          <div class="sub">
            <div class="items">
              <p>Enterprise Bank Account</p>
              <p>{{ pdfContent.enterprice }}</p>
            </div>
            <div class="items">
              <p>Enterprise Rate</p>
              <p>{{ pdfContent.enterpriseRate }}</p>
            </div>
          </div>
          <div class="sub">
            <div class="items">
              <p>Client Name</p>
              <p>{{ pdfContent.clientName }}</p>
            </div>
          </div>

          <div class="sub">
            <div class="items">
              <p>Product</p>
              <p>{{ pdfContent.products }}</p>
            </div>
            <div class="items">
              <p>Name</p>
              <p>{{ pdfContent.fileName }}</p>
            </div>
            <div class="items">
              <p>BENEFICIARY ADDRESS</p>
              <p>{{ pdfContent.address }}</p>
            </div>
            <div class="items">
              <p>A/C NO</p>
              <p>{{ pdfContent.iban }}</p>
            </div>

            <div class="items">
              <p>SWIFT CODE</p>
              <p>{{ pdfContent.swift }}</p>
            </div>
            <div class="items" v-if="pdfContent.refNum">
              <p>REFERENCE NO</p>
              <p>{{ pdfContent.refNum }}</p>
            </div>
            <div class="items">
              <p>BANK NAME</p>
              <p>{{ pdfContent.bankName }}</p>
            </div>
          </div>

          <div class="sub">
            <div class="items">
              <p>Amount</p>
              <p>{{ pdfContent.amount }}</p>
            </div>
            <div class="items">
              <p>Transfer Date</p>
              <p>{{ pdfContent.created_at }}</p>
            </div>
            <div class="items">
              <p>Transfer Status</p>
              <p v-if="pdfContent.status == 'pending'">Pending</p>
              <p v-if="pdfContent.status == 'confirmed'">Confirmed</p>
              <p v-if="pdfContent.status == 'refused'">Refused</p>
              <p v-if="pdfContent.status == 'finished'">Finished</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <transition name="fade-bounce">
      <button v-show="showScrollTop" class="return-to-top" @click="scrollToTop">
        <i class="fal fa-chevron-up"></i>
      </button>
    </transition>    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import StatsCard from "./../../../components/Charts/ChartComponent.vue";
import SearchSection from "@/components/Search/enterpriseAction";
import SearchRecoredSection from "@/components/Search/DailyClose";
export default {
  components: {
    StatsCard,
    SearchSection,
    SearchRecoredSection,
  },

  data() {
    return {
      // loadingBtnDialog
      loadingBtnDialog: false,
      loadingBtnDialogDailyClose: false,
      showScrollTop: false,

      // search
      searchItems: null,
      searchCompany: null,
      searchRecordItems: null,
      // loader
      loading: true,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: "كل تنفيذات شغل المؤسسات",
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItems: [
        {
          id: 1,
          icon: "fal fa-images",
          title: "تنفيذ شغل المؤسسات",
          number: "1",
        },
      ],

      // ========== dialog Status
      dialogShow: false,
      itemToShow: null,
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,

      // ========== dialog Daily Close
      dialogShowDailyClose: false,
      itemToShowDailyClose: null,
      dialogDeleteDailyClose: false,
      dialogDelete_selectedDailyClose: false,
      itemtoDeleteDailyClose: null,

      // ========== Filter
      show_filter: false,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      //Data
      data: {
        client_rate: null,
        bank_rate: null,
        totalAmount: null,
        subtraction: null,
        bank_comission: null,
      },

      // ========== Body Section
      calories: "",

      // ========== Your Data
      rows: [], // injected in created
      allWorks: [],
      allCalcItems: [],
      calcResult: 0,
      selectedEnterpriseId: null, // Track the first selected enterprise ID

      //========Recored Table
      last_amount: [],
      lodaing_amount: false,

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // Custom Modal Data

      // ========== Loding
      lodaing: false,
      table_length: null,
      calculater: {
        amount: null,
        mulit: null,
        divide: 1,
      },

      itemToCollectBalance: [],
      dialogCollectBalance: false,

      // pdf
      pdfContent: {
        fileName: null,
        enterprice: null,
        enterpriseRate: null,
        enterpriseTotal: null,
        clientName: null,
        country: null,
        address: null,
        iban: null,
        refNum: null,
        bankName: null,
        swift: null,
        products: null,
        amount: null,
        created_at: null,
        status: null,
      },
      companySearch: false,
      expanded: [],
      collapsedTables: {}, // Track collapsed state for each table by item id
      // excel data
      excelData: {
        name: " تنفيذ شغل المؤسسات",
        items: null,
        json_fields: {
          "Enterprice Name": {
            field: "name",
            callback: (value) => {
              var target = this.rows.find((ele) => {
                return ele.name == value;
              });
              var theLength = target.works.length;
              return (
                `<table><tbody><tr><td style='text-align: center; vertical-align: middle;' rowspan='${theLength}'>` +
                value +
                "</td></tr></tbody></table>"
              );
            },
          },
          "Total amount": {
            field: "works",
            callback: (value) => {
              let finalVal = "<table><tbody>";
              value.forEach((val, index) => {
                if (index == value.length - 1) {
                  finalVal +=
                    "<tr><td>" +
                    Number(val.paid).toLocaleString() +
                    "</td></tr>" +
                    "</tbody></table>";
                } else {
                  finalVal +=
                    "<tr><td>" +
                    Number(val.paid).toLocaleString() +
                    "</td></tr>";
                }
              });
              return finalVal;
            },
          },
          "Company Name": {
            field: "works",
            callback: (value) => {
              let finalVal = "<table><tbody>";
              value.forEach((val, index) => {
                if (index == value.length - 1) {
                  finalVal +=
                    "<tr><td>" +
                    val.company.name +
                    "</td></tr>" +
                    "</tbody></table>";
                } else {
                  finalVal += "<tr><td>" + val.company.name + "</td></tr>";
                }
              });
              return finalVal;
            },
          },
          "Client Name": {
            field: "works",
            callback: (value) => {
              let finalVal = "<table><tbody>";
              value.forEach((val, index) => {
                if (index == value.length - 1) {
                  finalVal +=
                    "<tr><td>" +
                    val.customer.name +
                    "</td></tr>" +
                    "</tbody></table>";
                } else {
                  finalVal += "<tr><td>" + val.customer.name + "</td></tr>";
                }
              });
              return finalVal;
            },
          },
          "Created at": {
            field: "works",
            callback: (value) => {
              let finalVal = "<table><tbody>";
              value.forEach((val, index) => {
                if (index == value.length - 1) {
                  finalVal +=
                    "<tr><td>" +
                    val.created_at +
                    "</td></tr>" +
                    "</tbody></table>";
                } else {
                  finalVal += "<tr><td>" + val.created_at + "</td></tr>";
                }
              });
              return finalVal;
            },
          },
          Status: {
            field: "works",
            callback: (value) => {
              let finalVal = "<table><tbody>";
              value.forEach((val, index) => {
                if (index == value.length - 1) {
                  finalVal +=
                    "<tr><td>" + val.status + "</td></tr>" + "</tbody></table>";
                } else {
                  finalVal += "<tr><td>" + val.status + "</td></tr>";
                }
              });
              return finalVal;
            },
          },
        },
      },

      //Deposit Dialog
      makeDepositDialog: false,
      load_users: false,
      itemToNotes: null,
      dialogNotes: false,

      // ========== Edit Daily Close Dialog
      dialogEditDailyClose: false,
      editBtnIsLoading: false,
      edit_data: {
        id: null,
        total_amount_collected: null,
        client_rate: null,
        bank_rate: null,
        bank_commission: null,
        amount_difference: null,
        work_ids: [],
      },
      // search
      searchOptions: {
        search_users: "",
      },
      users: null,

      // ========== Loading
      btnIsLoading: false,

      // Date_menues
      dateMenu: false,
      debit_dateMenu: false,

      // search_users
      search_users: "",

      // ========== create_data
      create_data: {
        username: null,
        amount: null,
        transfare_amount: 1,
        comission: 1,
        safe: null,
        date: new Date().toISOString().slice(0, 10),
        debit_date: null,
        desc: null,
        notes: null,
        collect_actions_id: null,
      },

      clicked_amount: null,

      // ========== Fixed_data
      safes: [],
      users: [],
    };
  },

  computed: {
    calculaterAll() {
      var amount = Number(this.calculater.amount.replace(/\D/g, ""));
      const num = (amount * this.calculater.mulit) / this.calculater.divide;
      return parseFloat(num.toFixed()).toLocaleString();
    },
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        var userType = JSON.parse(this.$store.state.usertype) || null;
        if (
          userType.includes("superadmin") ||
          (userType.includes("company_actions") &&
            userType.includes("confirm_company_actions"))
        ) {
          if (this.companySearch == true) {
            return [
              {
                text: "#",
                value: "index",
                sortable: false,
                align: "center",
                width: 10,
              },
              {
                text: " Total Amount ",
                value: "paid",
                align: "center",
                sortable: false,
                width: 200,
              },
              {
                text: " Company Name",
                value: "company.name",
                align: "center",
                width: 180,
              },
              {
                text: " Client Name",
                value: "customer.name",
                align: "center",
                width: 200,
              },
              {
                text: "Enterprise Account",
                value: "account.name",
                align: "center",
                width: 200,
              },
              {
                text: "Created at",
                value: "created_at",
                align: "center",
                sortable: false,
                width: 120,
              },
              {
                text: "Status",
                value: "status",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 120,
              },
              {
                text: "PDF File ",
                value: "pdf_file",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
              {
                text: "Confirm",
                value: "confirm",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
              {
                text: "Control",
                value: "actions",
                sortable: false,
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 100,
              },
            ];
          } else {
            return [
              {
                text: "#",
                value: "index",
                align: "center",
                sortable: false,
                width: 50,
              },
              {
                text: "حدد",
                value: "selected",
                align: "center",
                sortable: false,
                width: 55,
              },
              {
                text: " Total Amount ",
                value: "paid",
                align: "center",
                sortable: false,
                width: 200,
              },
              {
                text: " Company Name",
                value: "company.name",
                align: "center",
                width: 180,
              },
              {
                text: " Client Name",
                value: "customer.name",
                align: "center",
                width: 200,
              },
              {
                text: "Created at",
                value: "created_at",
                align: "center",
                sortable: false,
                width: 120,
              },
              {
                text: "collected",
                value: "is_collected",
                align: "center",
                sortable: false,
                width: 100,
              },
              {
                text: "Text Number",
                value: "companyLength",
                align: "center",
                sortable: false,
                width: 100,
              },
              {
                text: "Status",
                value: "status",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 120,
              },
              {
                text: "PDF File ",
                value: "pdf_file",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
              {
                text: "Confirmed",
                value: "confirm",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
              {
                text: "Control",
                value: "actions",
                sortable: false,
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 100,
              },
            ];
          }
        } else if (!userType.includes("confirm_company_actions")) {
          if (this.companySearch == true) {
            return [
              {
                text: "#",
                value: "index",
                sortable: false,
                align: "center",
                width: 10,
              },
              {
                text: " Total Amount ",
                value: "paid",
                align: "center",
                sortable: false,
                width: 200,
              },
              {
                text: " Company Name",
                value: "company.name",
                align: "center",
                width: 180,
              },
              {
                text: " Client Name",
                value: "customer.name",
                align: "center",
                width: 200,
              },
              {
                text: "Enterprise Account",
                value: "account.name",
                align: "center",
                width: 200,
              },
              {
                text: "Created at",
                value: "created_at",
                align: "center",
                sortable: false,
                width: 120,
              },
              {
                text: "Status",
                value: "status",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 120,
              },
              {
                text: "PDF File ",
                value: "pdf_file",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
              {
                text: "Confirm",
                value: "confirm",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
            ];
          } else {
            return [
              {
                text: " Total Amount ",
                value: "paid",
                align: "center",
                sortable: false,
                width: 200,
              },
              {
                text: " Company Name",
                value: "company.name",
                align: "center",
                width: 180,
              },
              {
                text: " Client Name",
                value: "customer.name",
                align: "center",
                width: 200,
              },
              {
                text: "Created at",
                value: "created_at",
                align: "center",
                sortable: false,
                width: 120,
              },
              {
                text: "Status",
                value: "status",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 120,
              },
              {
                text: "PDF File ",
                value: "pdf_file",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
            ];
          }
        } else {
          if (this.companySearch == true) {
            return [
              {
                text: "#",
                value: "index",
                sortable: false,
                align: "center",
                width: 10,
              },
              {
                text: " Total Amount ",
                value: "paid",
                align: "center",
                sortable: false,
                width: 200,
              },
              {
                text: " Company Name",
                value: "company.name",
                align: "center",
                width: 180,
              },
              {
                text: " Client Name",
                value: "customer.name",
                align: "center",
                width: 200,
              },
              {
                text: "Enterprise Account",
                value: "account.name",
                align: "center",
                width: 200,
              },
              {
                text: "Created at",
                value: "created_at",
                align: "center",
                sortable: false,
                width: 120,
              },
              {
                text: "Status",
                value: "status",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 120,
              },
              {
                text: "PDF File ",
                value: "pdf_file",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
              {
                text: "Control",
                value: "actions",
                sortable: false,
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 100,
              },
            ];
          } else {
            return [
              {
                text: " Total Amount ",
                value: "paid",
                align: "center",
                sortable: false,
                width: 200,
              },
              {
                text: " Company Name",
                value: "company.name",
                align: "center",
                width: 180,
              },
              {
                text: " Client Name",
                value: "customer.name",
                align: "center",
                width: 200,
              },
              {
                text: "Created at",
                value: "created_at",
                align: "center",
                sortable: false,
                width: 120,
              },
              {
                text: "Status",
                value: "status",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 120,
              },
              {
                text: "PDF File ",
                value: "pdf_file",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },

              {
                text: "Control",
                value: "actions",
                sortable: false,
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 100,
              },
            ];
          }
        }
      }
    },
    headers_amount() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            value: "index",
            sortable: false,
            align: "center",
            width: 10,
          },
          {
            text: "اسم الموظف",
            value: "collected_user.fullname",
            align: "center",
          },
          {
            text: "اجمالي المحدد",
            value: "total_amount_collected",
            align: "center",
          },
          {
            text: "عدد العمليات",
            value: "works",
            align: "center",
            width: 130,
          },
          {
            text: "ريت العميل",
            value: "client_rate",
            align: "center",
          },
          {
            text: "ريت البنك",
            value: "bank_rate",
            align: "center",
          },
          {
            text: "عمولة البنك",
            value: "bank_commission",
            align: "center",
            width: 130,
          },
          {
            text: "الفرق",
            value: "amount_difference",
            align: "center",
            width: 130,
          },
          {
            text: "التاريخ",
            value: "created_at",
            align: "center",
          },
          {
            text: "الوصف",
            value: "notes",
            align: "center",
            width: 130,
          },
          {
            text: "تفاصيل المعاملات",
            value: "details",
            align: "center",
            width: 130,
          },
          {
            text: "تأكيد",
            value: "confirm",
            align: "center",
          },
          {
            text: "العمليات",
            value: "actions",
            sortable: false,
            align: "center",
            width: 100,
          },
        ];
      }
    },
    rowsWithTotalPaid() {
      return this.rows.map((row) => {
        const totalPaid = row.works.reduce(
          (sum, work) => sum + Number(work.paid || 0),
          0,
        );

        return {
          ...row,
          totalPaid,
        };
      });
    },
    works_details_headers() {
      return [
        {
          text: "#",
          value: "index",
          sortable: false,
          align: "center",
          width: 10,
        },
        {
          text: " Total Amount ",
          value: "paid",
          align: "center",
          sortable: false,
          width: 200,
        },
        {
          text: " Company Name",
          value: "company.name",
          align: "center",
          width: 180,
        },
        {
          text: " Client Name",
          value: "customer.name",
          align: "center",
          width: 200,
        },
      ];
    },
    totalLastAmountCollected() {
      if (!this.last_amount) return 0;
      return this.last_amount.reduce(
        (sum, item) => sum + Number(item.total_amount_collected || 0),
        0
      );
    },
    totalLastAmountDifference() {
      if (!this.last_amount) return 0;
      return this.last_amount.reduce(
        (sum, item) => sum + Number(item.amount_difference || 0),
        0
      );
    },
    selectedEnterpriseName() {
      if (!this.selectedEnterpriseId) return "";
      const enterprise = this.rows.find(r => r.id === this.selectedEnterpriseId);
      return enterprise ? enterprise.name : "";
    },
    total() {
      const num =
        this.create_data.amount *
        this.create_data.comission *
        this.create_data.transfare_amount;
      return parseFloat(num.toFixed()).toLocaleString();
    },
  },

  methods: {
    handleScroll() {
      if (window.scrollY > 300) {
        this.showScrollTop = true;
      } else {
        this.showScrollTop = false;
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    toggleTableCollapse(itemId) {
      const item = this.rows.find((row) => row.id === itemId);
      if (item && item.works && item.works.length > 0) {
        this.$set(this.collapsedTables, itemId, !this.collapsedTables[itemId]);
      }
    },
    getTableItems(item) {
      if (!item.works) return [];
      if (item.works.length <= 0) return item.works;
      if (this.collapsedTables[item.id]) {
        return item.works.slice(0, 0);
      }
      return item.works;
    },
    columnClick(slotData) {
      const i = slotData.index;
      const indexExpanded = this.expanded.findIndex((i) => i === slotData.item);
      if (indexExpanded > -1) {
        this.expanded.splice(indexExpanded, 1);
      } else {
        this.expanded = [slotData.item];
      }
    },
    isSelected(item) {
      return this.selected.some((selected) => selected.id === item.id);
    },
    isAllSelected(items) {
      return items.length > 0 && items.every((item) => this.isSelected(item));
    },
    toggleSelect(item) {
      // if (this.singleSelect) {
      //   this.selected = [item];
      //   return;
      // }

      // const index = this.selected.findIndex(
      //   (selected) => selected.id === item.id
      // );
      // if (index > -1) {
      //   this.selected.splice(index, 1);
      // } else {
      //   this.selected.push(item);
      // }
      this.$axios({
        method: "POST",
        url: `client/company_work/save/${item.id}`,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 2000,
            message: "تم الحفظ بنجاح",
            position: "topRight",
          });
          item.is_saved = !item.is_saved;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message:
              (err.response && err.response.data && err.response.data.message) ||
              err.message,
            position: "topRight",
          });
        });
    },
    toggleSelectAll(items) {
      if (this.singleSelect) {
        this.selected = items.length ? [items[0]] : [];
        return;
      }

      if (this.isAllSelected(items)) {
        this.selected = this.selected.filter(
          (selected) => !items.some((item) => item.id === selected.id),
        );
      } else {
        const selectedIds = this.selected.map((item) => item.id);
        items.forEach((item) => {
          if (!selectedIds.includes(item.id)) {
            this.selected.push(item);
          }
        });
      }
    },

    // generate pdf
    generateReport(companyData) {
      document.title = companyData.company.name;
      this.pdfContent.fileName = companyData.company.name;
      this.pdfContent.enterprice = companyData.account.name;
      this.pdfContent.enterpriseRate = companyData.enterprise_rate;
      this.pdfContent.clientName = companyData.customer.name;
      this.pdfContent.country = companyData.company.country.name_ar;
      this.pdfContent.address = companyData.company.address;
      this.pdfContent.iban = companyData.company.account_number;
      this.pdfContent.refNum = companyData.reference;
      this.pdfContent.swift = companyData.company.swift_number;
      this.pdfContent.bankName = companyData.company.bank.name;
      this.pdfContent.products = companyData.company.products[0].name;
      this.pdfContent.amount = " SAR " + companyData.paid;
      this.pdfContent.enterpriseTotal =
        " SAR " + Number(companyData.enterprise_total).toLocaleString();
      this.pdfContent.created_at = companyData.created_at;
      this.pdfContent.status = companyData.status;
      setTimeout(() => {
        var iframePrint = document.querySelector(".iframePrint");
        var iframeHead = document.head.innerHTML;
        var printContents = document.querySelector(".pdf-print").innerHTML;
        iframePrint.contentWindow.document.write(iframeHead + printContents);
        setTimeout(() => {
          window.frames["printf"].print();
          iframePrint.contentWindow.document.close();
          document.title = "Golden Eyes";
        }, 500);
      }, 500);
    },
    calculate(amount) {
      this.showCalculater = !this.showCalculater;
      var money = Number(amount);
      this.calculater.amount = parseFloat(money.toFixed()).toLocaleString();
    },
    // searchTable
    searchTable(items) {
      if (items.company) {
        this.companySearch = true;
      } else {
        this.companySearch = false;
      }
      this.rows = [];
      this.allCalcItems = [];
      this.selectedEnterpriseId = null; // Reset selected enterprise when searching
      this.calcResult = 0;
      this.searchItems = items;
      this.searchCompany = items.company;
      this.setRows();
    },
    // searchRecordTable
    searchRecordTable(items) {
      this.last_amount = [];
      this.searchRecordItems = items;
      this.getRecordedEquationData();
    },
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/debits/add" });
    },
    showItem(item) {
      this.dialogShow = true;
      this.itemToShow = item;
    },
    editItem(item) {
      this.$router.push({ path: "/companyAction/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.loadingBtnDialog = true;
      this.$axios({
        method: "DELETE",
        url: `client/company_work/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.loadingBtnDialog = false;
          this.setRows();
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "topRight",
          });
          this.$store.dispatch("getTranshState");
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message:
              (err.response && err.response.data && err.response.data.message) ||
              err.message,
            position: "topRight",
          });
        });
    },

    // ===== Edit Daily Close
    editItemDailyClose(item) {
      this.edit_data.id = item.id;
      this.edit_data.total_amount_collected = item.total_amount_collected;
      this.edit_data.client_rate = item.client_rate;
      this.edit_data.bank_rate = item.bank_rate;
      this.edit_data.bank_commission = item.bank_commission;
      this.edit_data.amount_difference = item.amount_difference;
      this.edit_data.work_ids = item.works ? item.works.map((w) => Number(w.id)) : [];
      this.dialogEditDailyClose = true;
    },
    // ===== Update Equation Data
    updateEquationData() {
      if (this.editBtnIsLoading) return;

      // ===== Validation (same as main equation) =====
      if (!this.edit_data.total_amount_collected) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يجب أن يكون لديك قيمة للمبلغ الاجمالي",
          position: "topRight",
        });
        return;
      } else if (!this.edit_data.client_rate) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يجب أن يكون لديك قيمة لريت العميل",
          position: "topRight",
        });
        return;
      } else if (!this.edit_data.bank_rate) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يجب أن يكون لديك قيمة لريت البنك",
          position: "topRight",
        });
        return;
      }
      // ===== End Validation =====

      this.editBtnIsLoading = true;
      this.$axios({
        method: "PUT",
        url: `client/company_work_collect/${this.edit_data.id}`,
        data: {
          total_amount_collected: this.edit_data.total_amount_collected,
          client_rate: this.edit_data.client_rate,
          bank_rate: this.edit_data.bank_rate,
          bank_commission: this.edit_data.bank_commission,
          amount_difference: this.edit_data.amount_difference,
          // work_ids: this.edit_data.work_ids,
        },
      })
        .then(() => {
          this.editBtnIsLoading = false;
          this.dialogEditDailyClose = false;
          this.$iziToast.success({
            timeout: 2000,
            message: "تم التعديل بنجاح",
            position: "topRight",
          });
          this.getRecordedEquationData();
        })
        .catch((err) => {
          this.editBtnIsLoading = false;
          this.$iziToast.error({
            timeout: 2000,
            message:
              (err.response && err.response.data && err.response.data.message) ||
              err.message,
            position: "topRight",
          });
        });
    },
    // ===== Delete Daily Close
    deleteItemDailyClose(item) {
      this.dialogDeleteDailyClose = true;
      this.itemtoDeleteDailyClose = item;
    },
    deleteItemDailyCloseConfirm() {
      this.loadingBtnDialogDailyClose = true;
      this.$axios({
        method: "DELETE",
        url: `client/company_work_collect/${this.itemtoDeleteDailyClose.id}`,
      })
        .then(() => {
          this.loadingBtnDialogDailyClose = false;
          this.dialogDeleteDailyClose = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "topRight",
          });
          this.getRecordedEquationData();
        })
        .catch((err) => {
          this.dialogDeleteDailyClose = false;
          this.$iziToast.error({
            timeout: 2000,
            message:
              (err.response && err.response.data && err.response.data.message) ||
              err.message,
            position: "topRight",
          });
        });
    },
    // ==================== End CRUD ====================
    acceptCompany(id) {
      this.lodaing = true;
      this.$axios({
        method: "POST",
        url: "client/company_work/accept_company_work/" + id,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: "تأكيد بنجاح",
            position: "topRight",
          });
          this.setRows();
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message:
              (err.response && err.response.data && err.response.data.message) ||
              err.message,
            position: "topRight",
          });
          this.btnIsLoading = false;
        });
    },
    rejectCompany(id) {
      this.lodaing = true;
      this.$axios({
        method: "POST",
        url: "client/company_work/refuse_company_work/" + id,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: "مرفوض بنجاح",
            position: "topRight",
          });
          this.setRows();
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message:
              (err.response && err.response.data && err.response.data.message) ||
              err.message,
            position: "topRight",
          });
          this.btnIsLoading = false;
          this.lodaing = false;
        });
    },
    // Set Rows
    setRows() {
      this.lodaing = true;
      this.allWorks = [];
      this.$axios({
        method: "GET",
        url: "client/company_work/enterprise",
        params: {
          enterprise: this.searchItems ? this.searchItems.enterprice : "",
          customer: this.searchItems ? this.searchItems.username : "",
          company_id: this.searchItems ? this.searchItems.company : "",
          from_date: this.searchItems ? this.searchItems.from : "",
          to_date: this.searchItems ? this.searchItems.to : "",
          status: "confirmed",
        },
      })
        .then((res) => {
          this.rows = res.data.data;
          this.rows.forEach((ele) => {
            ele.works.forEach((mainEle) => {
              this.allWorks.push(mainEle);
              this.allWorks.forEach((subEle) => {
                if (mainEle.id == subEle.id) {
                  mainEle["indexNum"] = this.allWorks.indexOf(subEle, 0) + 1;
                }
              });
            });
            this.$set(ele, "totalPerClient", 0);
            this.$set(ele, "itemsToSum", []);
          });
          this.table_length = this.rows.length;
          this.excelData.items = this.rows;
          this.lodaing = false;
        })
        .catch((err) => {
          this.lodaing = false;
        });
    },
    //Total Amount
    totalAmount(ele, mainItem) {
      if (ele.is_collected) {
        this.$iziToast.error({
          timeout: 2000,
          message: "هذه العملية محددة من قبل",
          position: "topRight",
        });
        return;
      }

      const indexExpanded = this.allCalcItems.findIndex((i) => i.id === ele.id);

      // Check if unchecking an item
      if (indexExpanded > -1) {
        this.allCalcItems.splice(indexExpanded, 1);
        this.calcResult -= Number(ele.paid);

        // If no items are selected, reset the selected enterprise
        if (this.allCalcItems.length === 0) {
          this.selectedEnterpriseId = null;
        }
      } else {
        // Check if trying to select from a different enterprise
        if (
          this.selectedEnterpriseId !== null &&
          this.selectedEnterpriseId !== mainItem.id
        ) {
          this.$iziToast.error({
            timeout: 3000,
            message:
              "لا يمكنك تحديد عناصر من شركات مختلفة. يرجى إلغاء تحديد العناصر الحالية من الشركة الحالية أولاً",
            position: "topRight",
          });
          return;
        }

        // Set the selected enterprise ID if this is the first item
        if (this.selectedEnterpriseId === null) {
          this.selectedEnterpriseId = mainItem.id;
        }

        this.allCalcItems.push(ele);
        this.calcResult += Number(ele.paid);
      }

      // client total
      const found = mainItem.itemsToSum.find((el) => el.id == ele.id);
      if (found) {
        mainItem.itemsToSum = mainItem.itemsToSum.filter(
          (el) => el.id != found.id,
        );
        let total = 0;
        mainItem.itemsToSum.map((el) => (total += +el.paid));
        mainItem.totalPerClient = total;
      } else {
        mainItem.itemsToSum.push(ele);
        let total = 0;
        mainItem.itemsToSum.map((el) => (total += +el.paid));
        mainItem.totalPerClient = total;
      }
    },

    // Execute Equation
    executeEquation() {
      if (!this.data.totalAmount) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يجب أن يكون لديك قيمة للمبلغ الاجمالي",
          position: "topRight",
        });
        return;
      } else if (!this.data.client_rate) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يجب أن يكون لديك قيمة لريت العميل",
          position: "topRight",
        });
        return;
      } else if (!this.data.bank_rate) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يجب أن يكون لديك قيمة لريت البنك",
          position: "topRight",
        });
        return;
      }
      if (!this.allCalcItems.length) {
        this.$iziToast.error({
          timeout: 2000,
          message:
            "يجب أن يكون لديك قيمة للمبلغ الاجمالي وريت العميل وريت البنك والعمليات المحددة المؤخذة في الاعتبار",
          position: "topRight",
        });
        return;
      }
      this.loadingBtnDialog = true;
      // Send JSON payload to keep work_ids numeric
      const submit_data = {
        total_amount_collected: this.data.totalAmount,
        client_rate: this.data.client_rate,
        bank_rate: this.data.bank_rate,
        amount_difference: this.data.subtraction,
        bank_commission: this.data.bank_comission,
        work_ids: this.allCalcItems.map((el) => Number(el.id)),
      };
      this.$axios({
        method: "POST",
        url: "client/company_work_collect",
        data: submit_data,
      })
        .then(() => {
          this.loadingBtnDialog = false;
          this.$iziToast.success({
            timeout: 2000,
            message: "تم الحفظ بنجاح",
            position: "topRight",
          });
          this.resetEquation(); // Reset equation after successful save
          this.setRows();
          this.getRecordedEquationData();
        })
        .catch((err) => {
          this.loadingBtnDialog = false;
          this.$iziToast.error({
            timeout: 2000,
            message:
              (err.response && err.response.data && err.response.data.message) ||
              err.message,
            position: "topRight",
          });
        });
    },
    // Reset Equation
    resetEquation() {
      this.data.totalAmount = null;
      this.data.client_rate = null;
      this.data.bank_rate = null;
      this.data.subtraction = null;
      this.allCalcItems = [];
      this.calcResult = 0;
      this.selectedEnterpriseId = null; // Reset selected enterprise
    },
    // Reset All
    resetAll() {
      this.resetEquation();
      this.setRows();
    },

    // Get Recorded Equation Data
    getRecordedEquationData() {
      this.lodaing_amount = true;
      this.$axios({
        method: "GET",
        url: "client/company_work_collect",
        params: {
          deposit_status: this.searchRecordItems.statusId,
          from_date: this.searchRecordItems.from,
          to_date: this.searchRecordItems.to,
        },
      })
        .then((res) => {
          this.last_amount = res.data.data;
          this.lodaing_amount = false;
        })
        .catch((err) => {
          this.lodaing_amount = false;
        });
    },

    //showCollectBalance
    showCollectBalance(item) {
      this.dialogCollectBalance = true;
      this.itemToCollectBalance = item;
    },

    //makeDepositDialog
    showMakeDepositDialog(item) {
      this.create_data.collect_actions_id = item.id;
      // this.clicked_amount = this.calcResult;
      this.create_data.amount = item.amount_difference;
      this.create_data.safe = this.safes.find((el) => el.id == 5);
      this.create_data.date = new Date().toISOString().slice(0, 10);
      this.create_data.desc = `اجمالي ${item.total_amount_collected} شركة (${item.works[0].account.enterprise_name}) - ريت البنك ${item?.bank_rate} - ريت العميل ${item?.client_rate} - عمولة البنك ${item?.bank_commission} - الفرق ${item?.amount_difference}`;
      this.makeDepositDialog = true;
    },

    // START:: GET SAFES
    getSafes() {
      this.$axios({
        method: "GET",
        url: `client/wallet?type=in`,
      })
        .then((res) => {
          this.safes = res.data.data;
        })
        .catch((err) => {
          console.log(err.response ? err.response.data : err.message);
        });
    },
    // END:: GET SAFES

    // get_filterd_users
    get_filterd_users(keyword) {
      this.load_users = true;
      this.$axios({
        method: "GET",
        url: `client/customer/search?keyword=${keyword}`,
      })
        .then((res) => {
          this.users = res.data.data;
          this.load_users = false;
        })
        .catch((err) => {
          this.load_users = false;
        });
    },

    // Validate Data
    validateCreateForm() {
      if (!this.btnIsLoading) {
        this.btnIsLoading = true;
        if (!this.create_data.username) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.clinet_name"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.create_data.amount) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.amount"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.create_data.transfare_amount) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.transfare_amount"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.create_data.comission) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.comission"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.total) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.total"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.create_data.safe) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.safe"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.create_data.date) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.date"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.create_data.desc) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.desc"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else {
          this.submitData();
          return;
        }
      }
    },
    emptyFormData() {
      this.create_data.amount = null;
      this.create_data.comission = 1;
      this.create_data.transfare_amount = 1;
      this.getSafes();
      this.create_data.safe = null;
      this.create_data.username = null;
      this.create_data.date = new Date().toISOString().slice(0, 10);
      this.create_data.desc = null;
      this.create_data.notes = null;
    },
    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("type", "in");
      submit_data.append(
        "collect_actions_id",
        this.create_data.collect_actions_id,
      );
      submit_data.append("client_type", "customer");
      submit_data.append("amount", this.create_data.amount);
      submit_data.append("commission", this.create_data.comission);
      submit_data.append("rate", this.create_data.transfare_amount);
      submit_data.append("total", Number(this.total.replace(/\D/g, "")));
      submit_data.append("wallet_id", this.create_data.safe.id);
      submit_data.append("balance_customer_id", this.create_data.username.id);
      submit_data.append("date", this.create_data.date);
      submit_data.append("desc", this.create_data.desc);
      if (this.create_data.notes) {
        submit_data.append("notes", this.create_data.notes);
      }
      this.$axios({
        method: "POST",
        url: "client/walletoperation",
        data: submit_data,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 5000,
            message:
              this.$t("addSuccess") +
              " " +
              " و اصبح رصيد العميل" +
              " " +
              res.data.data.balance_customer.currency.name_ar +
              " " +
              Number(res.data.wallet).toLocaleString(),
            position: "topRight",
          });
          this.btnIsLoading = false;
          this.emptyFormData();
          this.makeDepositDialog = false;
          this.getRecordedEquationData();
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message:
              (err.response && err.response.data && err.response.data.message) ||
              err.message,
            position: "topRight",
          });
          this.btnIsLoading = false;
        });
    },

    showNotes(item) {
      this.itemToNotes = `اجمالي ${Number(
        item.total_amount_collected,
      ).toLocaleString()} شركة (${
        item.works[0].account.enterprise_name
      }) - ريت البنك ${item?.bank_rate} - ريت العميل ${
        item?.client_rate
      } - عمولة البنك ${item?.bank_commission} - الفرق ${Number(
        item?.amount_difference,
      ).toLocaleString()}`;
      this.dialogNotes = true;
    },

    copyNotes() {
      if (!this.itemToNotes) return;

      // Create a temporary textarea element
      const textarea = document.createElement("textarea");
      textarea.value = this.itemToNotes;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();

      try {
        // Copy to clipboard
        const successful = document.execCommand("copy");
        if (successful) {
          this.$iziToast.success({
            timeout: 2000,
            message: "تم نسخ النص بنجاح",
            position: "topRight",
          });
        } else {
          throw new Error("Copy command failed");
        }
      } catch (err) {
        // Fallback for modern browsers
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard
            .writeText(this.itemToNotes)
            .then(() => {
              this.$iziToast.success({
                timeout: 2000,
                message: "تم نسخ النص بنجاح",
                position: "topRight",
              });
            })
            .catch(() => {
              this.$iziToast.error({
                timeout: 2000,
                message: "فشل نسخ النص",
                position: "topRight",
              });
            });
        } else {
          this.$iziToast.error({
            timeout: 2000,
            message: "فشل نسخ النص",
            position: "topRight",
          });
        }
      } finally {
        // Clean up
        document.body.removeChild(textarea);
      }
    },
  },

  watch: {
    [`searchOptions.search_users`](newVal, oldVal) {
      if (!newVal || newVal.length < 3) {
        this.users = null;
      } else {
        if (!newVal & (oldVal == "")) {
          this.get_filterd_users(oldVal);
        } else if ((newVal == "") & (oldVal != "")) {
          this.get_filterd_users(newVal);
        } else {
          this.get_filterd_users(newVal);
        }
      }
    },
    calcResult(newValue) {
      if (newValue) {
        this.data.totalAmount = newValue;
        const result =
          (this.data.client_rate - this.data.bank_rate) * this.calcResult -
          this.data.bank_comission;
        this.data.subtraction = Math.round(result * 100) / 100;
      }
    },
    "data.client_rate"(newValue) {
      if (newValue && this.data.bank_rate && this.data.bank_comission) {
        const result =
          (newValue - this.data.bank_rate) * this.calcResult -
          this.data.bank_comission;
        this.data.subtraction = Math.round(result * 100) / 100;
      }

      if (!this.data.client_rate) {
        this.data.subtraction = 0;
      }
    },
    "data.bank_rate"(newValue) {
      if (newValue && this.data.client_rate && this.data.bank_comission) {
        const result =
          (this.data.client_rate - newValue) * this.calcResult -
          this.data.bank_comission;
        this.data.subtraction = Math.round(result * 100) / 100;
      }

      if (!this.data.bank_rate) {
        this.data.subtraction = 0;
      }
    },
    "data.bank_comission"(newValue) {
      if (newValue && this.data.client_rate && this.data.bank_rate) {
        const result =
          (this.data.client_rate - this.data.bank_rate) * this.calcResult -
          newValue;
        this.data.subtraction = Math.round(result * 100) / 100;
      }
      if (!this.data.bank_comission) {
        this.data.subtraction = 0;
      }
    },
    "create_data.amount"(newValue) {
      if (newValue) {
        this.total = newValue;
      }
    },
    "create_data.comission"(newValue) {
      if (newValue) {
        this.total = newValue;
      }
    },

    // ===== Edit dialog auto-calculation watchers
    "edit_data.client_rate"(newValue) {
      const { bank_rate, bank_commission, total_amount_collected } = this.edit_data;
      if (newValue && bank_rate && total_amount_collected) {
        const result = (newValue - bank_rate) * total_amount_collected - (bank_commission || 0);
        this.edit_data.amount_difference = Math.round(result * 100) / 100;
      } else {
        this.edit_data.amount_difference = 0;
      }
    },
    "edit_data.bank_rate"(newValue) {
      const { client_rate, bank_commission, total_amount_collected } = this.edit_data;
      if (newValue && client_rate && total_amount_collected) {
        const result = (client_rate - newValue) * total_amount_collected - (bank_commission || 0);
        this.edit_data.amount_difference = Math.round(result * 100) / 100;
      } else {
        this.edit_data.amount_difference = 0;
      }
    },
    "edit_data.bank_commission"(newValue) {
      const { client_rate, bank_rate, total_amount_collected } = this.edit_data;
      if (client_rate && bank_rate && total_amount_collected) {
        const result = (client_rate - bank_rate) * total_amount_collected - (newValue || 0);
        this.edit_data.amount_difference = Math.round(result * 100) / 100;
      } else {
        this.edit_data.amount_difference = 0;
      }
    },
    "edit_data.total_amount_collected"(newValue) {
      const { client_rate, bank_rate, bank_commission } = this.edit_data;
      if (newValue && client_rate && bank_rate) {
        const result = (client_rate - bank_rate) * newValue - (bank_commission || 0);
        this.edit_data.amount_difference = Math.round(result * 100) / 100;
      } else {
        this.edit_data.amount_difference = 0;
      }
    },
  },

  // ======= hooks
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  created() {
    this.getSafes();
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    // permisions
    var userType = JSON.parse(this.$store.state.usertype) || null;
    if (
      !userType.includes("superadmin") &&
      !userType.includes("company_actions") &&
      !userType.includes("confirm_company_actions") &&
      !userType.includes("company_work_collect_actions")
    ) {
      this.$router.push("/");
    }
  },
};
</script>

<style lang="scss" scoped>
.check_style {
  .v-icon {
    color: #6890c6 !important;
  }
}

.info-pills-container{
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 5px;
  }
} 

// Simple and Creative Info Pill Animation
.info-pill {
  position: relative;
  overflow: hidden;
  animation: slideInBounce 0.6s ease-out;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.5),
      transparent
    );
    animation: shineSweep 3s ease-in-out infinite;
  }

  p {
    position: relative;
    z-index: 1;
    margin-bottom: 0;
  }

  span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    animation: numberPulse 2s ease-in-out infinite;
    transition: all 0.3s ease;

    i {
      animation: coinSpin 3s ease-in-out infinite;
      transition: transform 0.3s ease;
    }

    &:hover i {
      transform: rotate(360deg) scale(1.2);
    }

    &.redColor {
      animation: numberPulseRed 1.5s ease-in-out infinite;

      i {
        animation: coinSpinRed 2s ease-in-out infinite;
      }
    }
  }
}

// Animations
@keyframes slideInBounce {
  0% {
    opacity: 0;
    transform: translateY(-20px) scale(0.9);
  }
  60% {
    transform: translateY(5px) scale(1.02);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes pulseGlow {
  0%,
  100% {
    box-shadow: 0 4px 15px rgba(99, 102, 241, 0.2);
  }
  50% {
    box-shadow: 0 6px 25px rgba(99, 102, 241, 0.4);
  }
}

@keyframes shineSweep {
  0% {
    left: -100%;
  }
  50% {
    left: 100%;
  }
  100% {
    left: 100%;
  }
}

@keyframes numberPulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes numberPulseRed {
  0%,
  100% {
    transform: scale(1);
    filter: brightness(0.9);
  }
  50% {
    transform: scale(1.08);
    filter: brightness(1.25);
  }
}

@keyframes coinSpin {
  0%,
  100% {
    transform: rotate(0deg) scale(1);
  }
  25% {
    transform: rotate(-10deg) scale(1.1);
  }
  75% {
    transform: rotate(10deg) scale(1.1);
  }
}

@keyframes coinSpinRed {
  0%,
  100% {
    transform: rotate(0deg) scale(1);
  }
  25% {
    transform: rotate(-15deg) scale(1.15);
  }
  75% {
    transform: rotate(15deg) scale(1.15);
  }
}

.equation-wrapper .equation-content {
  background-color: #e3f2fd;
  padding: 14px 20px;
  border-radius: 10px;
  .main_title{
    h4{
      font-size: 1.2rem;
    }
  }
  form {
    display: flex;
    align-items: center;
    gap: 15px;
    .rate_calc {
      display: flex;
      align-items: center;
      gap: 15px;
    }
  }
}

.collapse-icon {
  cursor: pointer;
  font-size: 12px;
  color: #fff;
  background-color: #1f467a;
  transition: all 0.3s ease;
  padding: 6px !important;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px !important;
  height: 26px !important;
  i {
    color: #fff;
    font-size: 18px;
  }

  &:hover {
    background-color: #5981b6;
    color: #1f467a;
    transform: scale(1.1);
  }

  &.expanded {
    transform: rotate(0deg);
  }

  &.collapsed {
    transform: rotate(-90deg);
  }

  &:active {
    transform: scale(0.95);
  }
}

.no-data-collapsed {
  display: flex;
  justify-content: center;
  gap: 10px;
  p {
    font-size: 16px;
    font-weight: 500;
  }
}
.completed {
  color: #080;
}
.pending {
  color: #525e6e;
}

.v-dialog__content .v-dialog {
  width: 55% !important;
  max-width: 100% !important;
}
.my_card {
  background-color: var(--cardBgColor);
  border-radius: 12px;
  // box-shadow: 0 5px 10px var(--box-shadow);
  padding: 10px;
  overflow-y: auto;
  max-height: 90vh;
}

/* Return to top button */
.return-to-top {
  position: fixed;
  bottom: 35px;
  right: 14%;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1F467A, #3967a5);
  color: white;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(31, 70, 122, 0.4);
  z-index: 1000;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.return-to-top:hover {
  transform: translateY(-5px) scale(1.1);
  box-shadow: 0 8px 20px rgba(31, 70, 122, 0.6);
  background: linear-gradient(135deg, #3967a5, #1F467A);
}

.return-to-top i {
  transition: transform 0.3s ease;
}

.return-to-top:hover i {
  animation: floatingIcon 1.5s infinite ease-in-out;
}

@keyframes floatingIcon {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
}

.fade-bounce-enter-active, .fade-bounce-leave-active {
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.fade-bounce-enter, .fade-bounce-leave-to {
  opacity: 0;
  transform: translateY(20px) scale(0.5);
}

</style>
